import { Block, Typography } from '@xprog/prensa'
import React from 'react'
import InputArea from '../FaleConosco/Inputs'
import DropDownArea from './DropDown'

type FaleConoscoProps = {
  children?: any;
  slotTemplateCode?: any;
}

type StringsObject = {
  [key: string]: any;
}

const FaleConosco: React.FC<FaleConoscoProps> = (props) => {
  
  const getTextStrings = (): StringsObject => {
    let objectFromTemplate: StringsObject = {}
    try {
      objectFromTemplate = JSON.parse(props?.slotTemplateCode)
    } catch (e) {
      objectFromTemplate = { strings: {} }
    }
    return objectFromTemplate
  }
  
  const strings = getTextStrings()
  
  const shouldRenderDropDown = () => {
    if (!strings || typeof strings !== 'object') return false;

    const keys = Object.keys(strings);

    if (keys.length === 0) return false;

    if (keys.length === 1 && keys[0] === 'strings' && Object.keys(strings.strings || {}).length === 0) {
      return false;
    }

    return true;
  };

  return (
    <Block
      css={{
        align: ['column', 'left', 'middle'],
        px: '$4',
        mb: '$4',
        width: '100%',
        '@lg': {
          maxWidth: '904px',
        }
      }}
    >
      <Typography
        as='h1'
        css={{
          color: '#000',
          fontFamily: '$primary',
          fontSize: '18px',
          lineHeight: '21.6px',
          fontWeight: 500,
          mb: '$5',
          mt: '$10'
        }}>
          Fale conosco
      </Typography>
      <Typography
        css={{
          color: '#000',
          fontFamily: '$primary',
          fontSize: '16px',
          lineHeight: '21.6px',
          fontWeight: 400,
          mb: '$4',
        }}>
          Utilize este formulário para enviar-nos comentários, sugestões ou críticas.
      </Typography>
      <InputArea />
      {shouldRenderDropDown() && <DropDownArea strings={strings} />}
    </Block> 
  )
}

export default FaleConosco
